import React from 'react';
import clsx from 'clsx';
export var HeadingType;
(function (HeadingType) {
    HeadingType["H1"] = "h1";
    HeadingType["H2"] = "h2";
    HeadingType["H3"] = "h3";
    HeadingType["H4"] = "h4";
    HeadingType["H5"] = "h5";
    HeadingType["H6"] = "h6";
})(HeadingType || (HeadingType = {}));
const headingClassMap = {
    [HeadingType.H1]: 'heading1',
    [HeadingType.H2]: 'heading2',
    [HeadingType.H3]: 'heading3',
    [HeadingType.H4]: 'heading4',
    [HeadingType.H5]: 'heading5',
    [HeadingType.H6]: 'heading6',
};
export const Heading = ({ type = HeadingType.H2, className, children }) => {
    const HeadingTag = type;
    return <HeadingTag className={clsx(headingClassMap[type], className)}>{children}</HeadingTag>;
};
